// extracted by mini-css-extract-plugin
export var completionBody = "_ia-2";
export var completionCard = "_ia-0";
export var completionFooter = "_ia-3";
export var completionTitle = "_ia-1";